import { useState } from "react";
import { toast } from "react-toastify";
import { useSmsTemplates } from "views/settings-communication/api/hooks";
import { smsTemplatesApi } from "views/settings-communication/api/api";
import { buildInboxEditorHtml } from "./link-variable-utils";
import {
  PickerShell,
  TemplateSearchList,
  type TemplateOption
} from "./TemplatePicker";

const useSmsTemplateSearch = (search: string) => {
  const { data, isLoading, isError } = useSmsTemplates(1, 100, {
    order_by: "name",
    order_direction: "asc",
    ...(search ? { search } : {})
  });
  return { items: data?.items ?? [], isLoading, isError };
};

export const SmsTemplateSelect = ({
  contactId,
  toNumber,
  onSelect,
  disabled = false
}: {
  contactId: number | undefined;
  toNumber?: string;
  onSelect: (content: string, html: string) => void;
  disabled?: boolean;
}) => {
  const [open, setOpen] = useState(false);
  const [rendering, setRendering] = useState(false);
  const { data: probe } = useSmsTemplates(1, 1);

  const handlePick = async (template: TemplateOption & { body: string }) => {
    if (!contactId) return;
    setRendering(true);
    try {
      const { rendered_body, variable_values } = await smsTemplatesApi.render(
        template.id,
        contactId,
        { toNumber }
      );
      onSelect(
        rendered_body,
        buildInboxEditorHtml(template.body, variable_values)
      );
      setOpen(false);
    } catch {
      toast.error("Failed to load template");
    } finally {
      setRendering(false);
    }
  };

  return (
    <PickerShell
      hidden={!probe?.total_count}
      disabled={disabled || !contactId}
      open={open}
      onOpenChange={setOpen}
    >
      <TemplateSearchList
        label="SMS templates"
        inputId="sms-template-search"
        useTemplates={useSmsTemplateSearch}
        busy={rendering}
        onClose={() => setOpen(false)}
        onPick={handlePick}
      />
    </PickerShell>
  );
};
